import * as React from "react";
import { FoodAlcoholModel, FoodAlcoholFilterSettingsModel, FoodAlcoholGridModel } from "../../../models/foodAndAlcohol";
import FoodAlcoholList from './foodAlcoholList';
import FoodAlcoholService from '../../../services/foodAlcoholService';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import { FoodAlcoholFilter } from './foodAlcoholFilter';
import FoodAlcoholAddEditDialog from './foodAlcoholAddEditDialog';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { Lang } from '../../../common/enums';
import { FoodAlcoholContentModel } from '../../../models/foodAndAlcohol/foodAlcoholContentModel';

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./diseasesAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
  foodAlcohols: Array<FoodAlcoholModel>;
  isLoading: boolean;
  error: any;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
  currentFoodAlcohol: FoodAlcoholModel;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  foodAlcoholSettings: FoodAlcoholFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 20;

class FoodAlcoholContainer extends React.Component<IProps, IState> {
  foodAlcoholService = new FoodAlcoholService();
  messages: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      foodAlcohols: new Array<FoodAlcoholModel>(0),
      isLoading: false,
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
      currentFoodAlcohol: new FoodAlcoholModel(),
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      foodAlcoholSettings: new FoodAlcoholFilterSettingsModel()
    };
  }

  // events
  componentDidMount() {
    this.getAllFoodAlcohols(this.state.from, this.state.numberOfRows);
  }

  // handles
  handleAddAndEditClick = id => {
    if (!id) { // Add			
      let foodAlcohol = new FoodAlcoholModel();
      let contentList = new Array<FoodAlcoholContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new FoodAlcoholContentModel();
        content.langId = parseInt(Lang[k]);
        content.foodAndAlcoholName = '';
        content.description = '';
        contentList.push(content);
      });

      foodAlcohol.foodAlcoholContent = contentList;
      this.setcurrentFoodAlcohol(foodAlcohol);
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.foodAlcoholService.getFoodAlcohol(id)
        .then(
          (data: FoodAlcoholModel) => {
            this.setcurrentFoodAlcohol(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.setState({
              error,
              isLoading: false
            });
          }
        );
    }
  };

  getFoodAlcohol = (id) => {
    this.foodAlcoholService.getFoodAlcohol(id)
      .then(
        (data: FoodAlcoholModel) => {
          this.setcurrentFoodAlcohol(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleDeleteClick = (id) => {
    this.getFoodAlcohol(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteFoodAlcohol(id) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.foodAlcoholService.deleteFoodAlcohol(id)
      .then(
        data => {
          this.getAllFoodAlcohols(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSaveButton = (currentFoodAlcohol: FoodAlcoholModel) => {
    this.setState({
      isLoading: true
    });

    if (!currentFoodAlcohol.foodAlcoholId) { // Add
      this.foodAlcoholService.addFoodAlcohol(currentFoodAlcohol)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentFoodAlcohol(new FoodAlcoholModel());
            this.getAllFoodAlcohols(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentFoodAlcohol(new FoodAlcoholModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.foodAlcoholService.editFoodAlcohol(currentFoodAlcohol.foodAlcoholId, currentFoodAlcohol)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentFoodAlcohol(new FoodAlcoholModel());
            this.getAllFoodAlcohols(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentFoodAlcohol(new FoodAlcoholModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  // methods
  getAllFoodAlcohols(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.foodAlcoholService.getAllFoodAlcohols(from, numberOfRows, this.state.foodAlcoholSettings).then(
      (data: FoodAlcoholGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          foodAlcohols: data.foodAlcohols,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  setcurrentFoodAlcohol(foodAlcohol: FoodAlcoholModel) {
    this.setState({ currentFoodAlcohol: { ...foodAlcohol } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialogWrap: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleDialog: show
    }));
  };

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllFoodAlcohols(startIndex, this.state.numberOfRows);
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true
    });

    this.foodAlcoholService.getAllFoodAlcohols(initFrom, numberOfRows, settings).then(
      (data: FoodAlcoholGridModel) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          foodAlcohols: data.foodAlcohols,
          foodAlcoholSettings: settings,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  // render
  public render() {

    const { foodAlcohols, isLoading, error } = this.state;

    return (
      <div>

        <h3>Foods and Alcohols</h3>

        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        {this.state.isVisibleDialogWrap ? (
          <FoodAlcoholAddEditDialog
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
            currentfoodAlcohol={this.state.currentFoodAlcohol}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <div className="mb-2">
          <button
            onClick={() => this.handleAddAndEditClick(null)}
            className="btn btn-success"
            style={{ marginRight: "5px" }}>
            Add New
          </button>
        </div>

        <FoodAlcoholFilter
          onSearchClick={this.handleSearchButtonClick}
          totalRecordsCount={this.state.totalRecordsCount}
        />

        <FoodAlcoholList
          foodAlcohols={foodAlcohols}
          rows={numberOfRows}
          totalRecords={this.state.totalRecordsCount}
          onPageClick={this.handleOnPageClick}
          first={this.state.from}
          loading={Spinner}
          editClick={this.handleAddAndEditClick}
          deleteClick={this.handleDeleteClick}
        />

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteFoodAlcohol(this.state.currentFoodAlcohol.foodAlcoholId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentFoodAlcohol.foodAlcoholNameBG}"?
        </ConfirmDialog>
      </div>
    );
  }
}

export default FoodAlcoholContainer;